"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgWarning = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", d: "M23.377 16.986L15.456 3.064c-1.547-2.671-5.391-2.671-6.938 0L.596 16.986c-1.5 2.672.422 5.953 3.469 5.953h15.89c3.047 0 4.97-3.328 3.422-5.953zm-12.375-9a.99.99 0 01.985-.984c.515 0 .984.469.984.984v6a.99.99 0 01-.984.985c-.516 0-.985-.469-.985-.985v-6zm.985 11.438a1.46 1.46 0 01-1.453-1.453 1.46 1.46 0 011.453-1.453 1.46 1.46 0 011.453 1.453 1.46 1.46 0 01-1.453 1.453z" })));
};
exports.default = SvgWarning;
//# sourceMappingURL=Warning.js.map